/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import EventCard from './EventCard';

import * as AppPropTypes from '../../lib/PropTypes';

import styles from '../../../styles/partials/event-cards.scss';

const propTypes = {
    items: AppPropTypes.pages,
    format: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    items: [],
    format: null,
    className: null,
};

const EventCards = ({ items, format, className }) => {
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            {items.map((evt, i) => (
                <EventCard
                    className={format !== 'small' ? styles.single : null}
                    key={`card-${i + 1}`}
                    {...evt}
                    index={i}
                    format={format}
                    borders={
                        format === 'small' || (i + 1) % 2 === 0
                            ? {
                                  top: true,
                                  right: true,
                                  bottom: false,
                                  left: false,
                              }
                            : {
                                  top: true,
                                  right: true,
                                  bottom: true,
                                  left: true,
                              }
                    }
                />
            ))}
        </div>
    );
};

EventCards.propTypes = propTypes;
EventCards.defaultProps = defaultProps;

export default EventCards;
